/**
 * @description 介绍
*/
import React, {useState} from "react";
import { ImageViewer } from 'antd-mobile';
import { useHistory } from 'react-router-dom';
import JsBridge from 'library/jsbridge';
import styles from './index.module.scss';
import tipsImg from 'images/kangyang/biaoti-icon@2x.png';
import picture1 from 'images/kangyang/kangyang-1@2x.png';
import picture2 from 'images/kangyang/kangyang-2@2x.png';
import picture3 from 'images/kangyang/kangyang-3@2x.png';
import picture4 from 'images/kangyang/kangyang-4@2x.png';
import picture5 from 'images/kangyang/kangyang-5@2x.png';
import picture6 from 'images/kangyang/kangyang-6@2x.png';
import picture7 from 'images/kangyang/kangyang-7@2x.png';
import icon1 from 'images/kangyang/houniao-1@2x.png';
import icon2 from 'images/kangyang/houniao-2@2x.png';
import icon3 from 'images/kangyang/liaoyang-1@2x.png';
import icon4 from 'images/kangyang/liaoyang-2@2x.png';
import icon5 from 'images/kangyang/wenhua-1@2x.png';
import icon6 from 'images/kangyang/wenhua-2@2x.png';
import icon7 from 'images/kangyang/tianyuan-1@2x.png';
import icon8 from 'images/kangyang/tianyuan-2@2x.png';

export const Introduce = ()=> {
    const history = useHistory();

    const renderIntroduce = () => {
        return <div className={styles.old_introduce}>
            <img className={styles.topImg} src={picture1} />
            <p>2018年，康养产业集团正式推出绿地康养居，面向健康活力老人的旅居养老度假产品，以康养酒店为载体，以会员俱乐部为平台，以健康养生、主题文化活动为特色。绿地康养居，致力于成为百姓首选的健康快乐养老生活设计专家！</p>
            <h2>全新生活方式</h2>
            <img className={styles.img} src={picture2} />
            <p>在健康、养生、轻松、安全的环境下，休闲娱乐、旅居交友，心情愉悦，享受康养居带来的健康和快乐。</p>
            <h2>会员俱乐部平台</h2>
            <img className={styles.img} src={picture3} />
            <p>汇集一群乐于享受高品味生活的会员，帮助他们利用闲暇时光边游边养，扩大社交圈，提高养老生活的质量。</p>
            <h2>创新服务模式</h2>
            <img className={styles.img} src={picture4} />
            <p>创新康养服务模式，六大服务体系，健康助理、快乐助理全程陪伴，“更健康·更快乐”全新服务体验。</p>
            <h2>战略布局发展</h2>
            <img className={styles.img} src={picture5} />
            <p>绿地康养居战略布局全国省会、旅游城市、风景区、特色小镇等区域，打造专业化旅居酒店。 现已有四川成都、湖北武汉、江西南昌、苏州昆山、浙江宁波、江苏盐城、广东阳江、贵州贵阳、甘肃兰州、宁夏银川等10余家 “绿地康养居”落成，有超过30家的“绿地康养居”已经纳入规划，正在加紧建设中。</p>
            <div className={styles.title}>
                <img src={tipsImg} className={styles.icon} />
                <h3 className={styles.titleText}>四种生活随心选择</h3>
                <img src={tipsImg} className={`${styles.icon} ${styles.transfer}`} />
            </div>
            <h3>候鸟式养老生活</h3>
            <div>
                <div className={styles.row}>
                    <div className={styles.item}>
                        <img className={styles.icon} src={icon1} />
                        <div className={styles.textBg}>
                            <h4 className={styles.text}>享三亚的暖冬美景</h4>
                        </div>

                    </div>
                    <div className={styles.item}>
                        <img className={styles.icon} src={icon2} />
                        <div className={styles.textBg}>
                            <h4 className={styles.text}>享盘山的清凉夏日</h4>
                        </div>

                    </div>
                </div>
            </div>
            <h3>疗养式养老生活</h3>
            <div>
                <div className={styles.row}>
                    <div className={styles.item}>
                        <img className={styles.icon} src={icon3} />
                        <div className={styles.textBg}>
                            <h4 className={styles.text}>于峨眉山享清新的氧吧生活</h4>
                        </div>

                    </div>
                    <div className={styles.item}>
                        <img className={styles.icon} src={icon4} />
                        <div className={styles.textBg}>
                            <h4 className={styles.text}>于黄山享太平湖清静的世外桃源</h4>
                        </div>
                    </div>
                </div>
            </div>

            <h3>文化式养老生活</h3>
            <div>
                <div className={styles.row}>
                    <div className={styles.item}>
                        <img className={styles.icon} src={icon5} />
                        <div className={styles.textBg}>
                            <h4 className={styles.text}>于灵山九华参禅修佛、明心见性</h4>
                        </div>

                    </div>
                    <div className={styles.item}>
                        <img className={styles.icon} src={icon6} />
                        <div className={styles.textBg}>
                            <h4 className={styles.text}>游古戏今，红动南昌</h4>
                        </div>
                    </div>
                </div>
            </div>

            <h3>田园式养老生活</h3>
            <div>
                <div className={styles.row}>
                    <div className={styles.item}>
                        <img className={styles.icon} src={icon7} />
                        <div className={styles.textBg}>
                            <h4 className={styles.text}>绿地郫县康养居，走进中国第一家农家乐——农科村徐家大院</h4>
                        </div>
                    </div>
                    <div className={styles.item}>
                        <img className={styles.icon} src={icon8} />
                        <div className={styles.textBg}>
                            <h4 className={styles.text}>武汉绿地康养居体验木兰农耕年华农业度假生活</h4>
                        </div>
                    </div>
                </div>
            </div>

            <img className={styles.img2} src={picture6} />
            <img className={styles.img} src={picture7} />
        </div>
    }

    //了解更多
    const onMoreClick = (item)=> {
        if(JsBridge.hasWebViewBridge()) {
            JsBridge.push('CustomWeb', {uri: window.location.origin + `/front/guApp/kangyang/introduce-more?type=${item.index}`});
        }else {
            history.push(`/front/guApp/kangyang/introduce-more?type=${item.index}`)
        }
       
    }

    const Bservices = [
        {title: '健康保健服务', img: require('images/kangyang/introduce_base1.png')},
        {title: '医疗保障服务', img: require('images/kangyang/introduce_base2.png')},
        {title: '智能安康服务', img: require('images/kangyang/introduce_base3.png')},
        {title: '生活照料服务', img: require('images/kangyang/introduce_base4.png')},
        {title: '娱乐社交服务', img: require('images/kangyang/introduce_base5.png')},
        {title: '文化教育服务', img: require('images/kangyang/introduce_base6.png')},
    ]

    return (
        <div className={styles.Introduce}>
            <div className={styles.container}>
                <div className={styles.topBg} draggable={false}/>
                <div className={styles.body_bg}>
                    <div className={styles.header}>
                        <h2>绿地国际康养城 颐居生活新纪元</h2>
                    </div>
                    <p>绿地国际康养城是由绿地康养产业集团依托母公司世界500强雄厚资源，计划投资29.35亿筑造的集“医、康、养、旅、产、融”六大产业模式于一体的国际化综合性全龄康养社区。作为集团的标杆示范项目，绿地国际康养城结合国内市场需求、借鉴国外先进模式，为长者带来颐动颐静的全新退休生活体验。</p>
                    <img src={require('images/kangyang/introduce_p1.png')} draggable={false}/>
                    <div className={styles.card}>
                        <p>绿地国际康养城坐落于上海市青浦区朱家角这一交通便捷的休闲度假养生地，依托周边丰富文旅资源以及上海锦欣国松护理院、中山医院青浦分院、朱家角人民医院等优质医疗资源，打造出一处自然与人文兼具的生态天然养心居。</p>
                    </div>
                    <div className={styles.header}>
                        <h2>2025年，绿地颐尚居迎来升级元年</h2>
                    </div>
                    <div className={styles.space}></div>
                    <div className={styles.row}>
                        <div>
                            <img className={styles.img} src={require('images/kangyang/introduce_p2@2x.png')} draggable={false}/>
                        </div>
                        <div className={styles.pas}></div>
                        <div>
                            1月，联合青浦区长护险机构推出“暖心卡”活动，持续升级会员权益。 
                        </div>
                    </div>
                    <div className={styles.row}>
                        <div>
                            2月，荣登“2024年度长三角十大最受欢迎养老项目”榜单。 
                        </div>
                        <div className={styles.pas}></div>
                        <div>
                            <img className={styles.img} src={require('images/kangyang/introduce_p3@2x.png')} draggable={false}/>
                        </div>
                        
                    </div>
                    <div className={styles.row}>
                        <div>
                            <img className={styles.img} src={require('images/kangyang/introduce_p4@2x.png')} draggable={false}/>
                        </div>
                        <div className={styles.pas}></div>
                        <div>
                            4月，斩获中房协“榜样的力量”——中国银发人居CCRC推荐项目。 
                        </div>
                    </div>
                    <div className={styles.row}>
                        <div>
                            7月， 携手东方医院、京东等头部伙伴，持续拓展跨界“朋友圈”。 
                        </div>
                        <div className={styles.pas}></div>
                        <div>
                            <img className={styles.img} src={require('images/kangyang/introduce_p5@2x.png')} draggable={false}/>
                        </div>
                        
                    </div>
                    <div className={styles.row}>
                        <div>
                            <img className={styles.img} src={require('images/kangyang/introduce_p6@2x.png')} draggable={false}/>
                        </div>
                        <div className={styles.pas}></div>
                        <div>
                            8月，上海锦欣国松护理院启动建设，深化“医康养结合”迈出关键一步。
                        </div>
                    </div>
                    <div className={[styles.row2,styles.mb25].join(' ')}>
                        创新不止，服务升级，我们一直在路上！<br/>
                        秉承“五心”服务理念，以“六颐”服务体系为基石， 为长者匠心打造一个温暖、健康、充满活力的颐养家园。
                    </div>

                    <div className={styles.header2}>
                        <div className={styles.header2_title}>优越环境 & 便捷交通</div>
                        <div className={styles.header2_subtitle}>择址青浦朱家角古镇，坐拥“上海养老圣地”生态基底</div>
                    </div>
                    <div className={[styles.row2,styles.mt125].join(' ')}>
                        <span>生态宜居：</span> 42%高绿化率，中央湖景环抱慢跑道，水系丰沛，负氧离子含量高。<br/>
                        <span>交通枢纽：</span> 占据青浦核心区位，30分钟速达虹桥机场/高铁站，7分钟接驳朱家角地铁站（社区班车直达），10分钟畅达千年朱家角古镇。
                    </div>
                    <div className={[styles.row3,styles.mt05].join(' ')}>
                        <div>
                            <img className={styles.img3} src={require('images/kangyang/introduce_p7@2x.png')} draggable={false}/>
                        </div>
                        {/* <div>
                            <img className={styles.img4} src={require('images/kangyang/introduce_p6@2x.png')} draggable={false}/>
                        </div> */}
                    </div>
                    <div className={[styles.row2,styles.mb25,styles.mt05].join(' ')}>
                        <span>江南雅韵：</span> 社区融合“江南水乡”意境与现代康养理念，风雨连廊无缝连接楼宇与功能区，无障碍通道全覆盖。<br/>
                        <span>安全适老：</span> 室内实施56项适老化细节（防滑地砖、圆角家具、淋浴折叠凳、紧急呼叫等），室外配套影院、大舞台、各类活动室（K歌、舞蹈、书画、乒乓、门球）等丰富设施。<br/>
                        <span>文旅环绕：</span> 毗邻朱家角古镇、淀山湖、东方绿舟、太阳岛、大观园等知名景点，满足长者休闲旅居需求；旁邻绿地康养居酒店，便捷接待探亲访友。
                    </div>

                    <div className={styles.header2}>
                        <div className={styles.header2_title}>多彩生活 & 活力社群</div>
                        <div className={styles.header2_subtitle}>全年活动不断升级，乐享颐养时光</div>
                    </div>
                    <div className={[styles.row3,styles.mt125,styles.mb25].join(' ')}>
                        <div className={styles.text2}>
                            <span>常态化主题：</span> 精心策划手工、乐队、茶艺等六大主题文化活动。<br/>
                            <span>节日新体验：</span> 融合传统民俗与现代创意，打造七大节日主题盛宴。<br/>
                            <span>年度新亮点：</span> 2025年新增社区运动会、书法交流、手机摄影等8类特色活动，覆盖健身、艺术、科技、安全等多维需求，深化“老有所乐、全龄共融”。<br/>
                            <span>明星零距离：</span> 特邀一线老年艺术家（唐群）走进社区，与长者偶像面对面互动。
                        </div>
                        <div>
                            <img className={styles.img5} src={require('images/kangyang/introduce_p8@2x.png')} draggable={false}/>
                            {/* <img className={styles.img6} src={require('images/kangyang/introduce_p6@2x.png')} draggable={false}/> */}
                        </div>
                    </div>

                    <div className={styles.header2}>
                        <div className={styles.header2_title}>专业医康养 & 智慧护航</div>
                        <div className={styles.header2_subtitle}>家门口的医疗健康保障</div>
                    </div>
                    <div className={[styles.row2,styles.mt125].join(' ')}>
                        <span>上海锦欣国松护理院：</span> 社区内万方级专业护理机构（1.1万㎡），运营后将提供268张床位，秉承“特色专科+特色护理”。<br/>
                        <span>智慧化管理：</span> 运用健康大数据分析、紧急响应系统，推动区域养老护理升级。<br/>
                        <span>绿色通道：</span> 逐步与市区综合医院建立战略合作，开通便捷就医分诊、转诊通道，精准满足社区多元医疗需求。
                    </div>
                    <div className={[styles.row3,styles.mt05,styles.mb25].join(' ')}>
                        <div>
                            <img className={styles.img3} src={require('images/kangyang/introduce_p9@2x.png')} draggable={false}/>
                        </div>
                        {/* <div>
                            <img className={styles.img4} src={require('images/kangyang/introduce_p6@2x.png')} draggable={false}/>
                        </div> */}
                    </div>

                    <div className={styles.header2}>
                        <div className={styles.header2_title}>贴心管家 & 温暖相伴</div>
                        <div className={styles.header2_subtitle}>专属团队，全程守护</div>
                    </div>
                    <div className={[styles.row2,styles.mt125].join(' ')}>
                        <span>三大管家体系：</span> “健康管家+生活管家+文娱管家”全方位覆盖医疗、起居、文娱需求。<br />
                        <span>家文化引领：</span> 以“家文化”为核心，提供7×24小时有温度、有回应的贴心服务。
                    </div>
                    <div className={[styles.row3,styles.mt05].join(' ')}>
                        <div>
                            <img className={styles.img3} src={require('images/kangyang/introduce_p10@2x.png')} draggable={false}/>
                        </div>
                        {/* <div>
                            <img className={styles.img4} src={require('images/kangyang/introduce_p6@2x.png')} draggable={false}/>
                        </div> */}
                    </div>

                    {/* <div className={styles.header}>
                        <h2>六颐服务 双重会籍</h2>
                        <span>/Service Membership</span>
                    </div>
                    <p>项目一期颐尚居定位为会籍制康养社区，涵盖颐养公寓、服务中心及配套商业从颐身、颐年、颐家、颐贤、颐神、颐志六个方面构建“六颐”服务体系。颐尚居通过健康助理、生活助理、快乐助理三大助理，提供108项专业化服务更全面采用了56项适老化配置，贴心细致，安全舒适，让会员乐养于此，幸福所居。</p>
                    <img className={styles.img} src={require('images/kangyang/introduce_p4.png')} draggable={false}/> */}

                    <div className={styles.header_center}>
                        <div>
                            <img src={require('images/kangyang/icon_star.png')} alt="" draggable={false}/>
                            <h2>颐尚居-基础服务</h2>
                            <img src={require('images/kangyang/icon_star.png')} alt="" draggable={false}/>
                        </div>
                        {/* <span>Basic services</span> */}
                    </div>
                    <div className={styles.service_box}>
                    {
                        Bservices.map((item,index)=>{
                            item.index = index;
                            return <div key={index} className={styles.service_item} onClick={()=>onMoreClick(item)}>
                                <div>
                                    <img src={item.img} alt="" draggable={false}/>
                                    <span>{item.title}</span>
                                </div>
                                <div>
                                    <span>了解详情</span>
                                </div>
                            </div>
                        })
                    }
                    </div>
                    <div className={styles.header_center}>
                        <div>
                            <img src={require('images/kangyang/icon_star.png')} alt="" draggable={false}/>
                            <h2>康养城地址</h2>
                            <img src={require('images/kangyang/icon_star.png')} alt="" draggable={false}/>
                        </div>
                        <span>Health City Address</span>
                    </div>
                    <img className={styles.img} src={require('images/kangyang/introduce_p6.png')} 
                        draggable={false}
                        onClick={()=>{
                            ImageViewer.show({image: require('images/kangyang/introduce_p6.png')})
                        }}
                    />
                    <div className={styles.footmb}></div>
                </div>
            </div>
            
        </div>
    );

}